import { Translation } from '@ps/web-shared-components';
import type { SgmData } from '@ps/web-sports-api-types';
import React from 'react';

import {
  TXTWCL_1_event,
  TXTWCL_N0_events,
  TXTWCL_N0_legs
} from './SgmEventAndLegCount.messages.json';
import styles from './SgmEventAndLegCount.scss';

interface Props {
  sgmData: SgmData[];
}

export const SgmEventAndLegCount: React.FC<Props> = ({ sgmData }) => {
  const numberOfEvents = sgmData.length;
  const numberOfLegs = sgmData.reduce((acc, event) => acc + event.descriptions.length, 0);

  return (
    <div className={styles.countWrapper}>
      (
      <Translation
        {...(numberOfEvents === 1 ? TXTWCL_1_event : TXTWCL_N0_events)}
        values={{ 0: numberOfEvents }}
      />
      {' - '}
      <Translation {...TXTWCL_N0_legs} values={{ 0: numberOfLegs }} />)
    </div>
  );
};
